import './wdyr';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import AccountDetail from './templates/AccountDetail';
import CameraList from './templates/CameraList';
import CameraDetail from './templates/CameraDetail';
import CameraStats from './templates/CameraStats';
import CameraSettings from './templates/CameraSettings';

import { Container, createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import AppHeader from './components/Header';
import ScrollTop from './components/BackToTop';
import { blue, grey, orange } from '@mui/material/colors';
import PlayerDetail from './templates/PlayerDetail';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from './graphql/apollo/client';
import AuthenticationContext from './components/AuthenticationContext';
import CameraAdmin from './templates/CameraAdmin';
import PlayerView from './templates/PlayerView';

declare module '@mui/material/styles/createPalette' {
  interface Palette {
    neutral: Palette['primary'];
  }
  interface PaletteOptions {
    neutral: PaletteOptions['primary'];
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    neutral: true;
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: blue[500],
    },
    secondary: {
      main: orange[500],
    },
    neutral: {
      main: grey[500],
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <ApolloProvider client={apolloClient}>
        <AuthenticationContext>
          <BrowserRouter>
            <CssBaseline />
            <AppHeader />
            <Container maxWidth="md" style={{ padding: '12px' }}>
              <Switch>
                <Route path="/camera/:cameraId/player/:id/settings" component={PlayerDetail} />
                <Route path="/camera/:cameraId/player/:id" component={PlayerView} />
                <Route path="/stats/camera/:id" component={CameraStats} />
                <Route path="/camera/:id/settings" component={CameraSettings} />
                <Route path="/camera/:id/admin" component={CameraAdmin} />
                <Route path="/camera/:id" component={CameraDetail} />
                <Route path="/account" component={AccountDetail} />
                <Route path="/" component={CameraList} />
              </Switch>
            </Container>
            <ScrollTop />
          </BrowserRouter>
        </AuthenticationContext>
      </ApolloProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
